/*
 * @Author: your name
 * @Date: 2021-02-23 14:01:56
 * @LastEditTime: 2021-03-16 19:49:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /sunyur/fe-mall/pages/index/src/router/evaluate.js
 */
export default {
  fixed: [
    {
      name: 'evaluate-detail',
      path: '/evaluate/detail',
      component: () => import(/* webpackChunkName: "evaluate-detail" */'../routes/evaluate/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '查看评价',
          en: '查看评价_en',
          jp: '查看评价_jp'
        },
        spmB: 'b228',
        isNewHeader: true,
        menuCode: '/evaluate'
      }
    },
    {
      name: 'evaluate-edit',
      path: '/evaluate/edit',
      component: () => import(/* webpackChunkName: "evaluate-edit" */'../routes/evaluate/edit/index.vue'),
      meta: {
        title: {
          'zh-CN': '评价',
          en: '评价_en',
          jp: '评价_jp'
        },
        spmB: 'b229',
        isNewHeader: true,
        menuCode: '/evaluate'
      }
    }
  ],
  fluid: [
    {
      name: 'evaluate',
      path: '/evaluate',
      component: () => import(/* webpackChunkName: "evaluate" */'../routes/evaluate/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的评价',
          en: '我的评价_en',
          jp: '我的评价_jp'
        },
        spmB: 'b230',
        isNewHeader: true
      }
    }
  ]
}
